
















import { computed, defineComponent, PropType } from '@vue/composition-api';

import { OmittedAuthorsType } from './@type';
import { KidsBookAuthorDTO, KidsBookAuthorType } from '@/apis/repositories/types/kids';
import { WTitle } from '@/components/base';
import LineBreakElement from '@/components/base/wrapper/LineBreakElement.vue';
import { commonCodeStore } from '@/store';

type KidsBookAuthorInfo = KidsBookAuthorDTO & {
  typeText: string;
};

export default defineComponent({
  name: 'BookInfoAuthorProfile',
  components: { WTitle, LineBreakElement },
  props: {
    authors: {
      type: Array as PropType<OmittedAuthorsType>,
      default: () => [],
    },
    isKidsBook: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const getTypeText = (typeCode: KidsBookAuthorType) => {
      const authorTypeText = commonCodeStore.listItem('KidsBookAuthorType', typeCode as KidsBookAuthorType).text;

      return authorTypeText;
    };

    /*
    키즈 타입일 때
    1. 작가 타입 텍스트 필드(typeText) 추가
    2. 작가가 중복되는 경우(seq가 같음) 배열에서 중복 제거 후 typeText에 작가 타입 나열

    [
        {
        "seq": 2907,
        "type": "SCENARIO",
        "name": "요시타케 신스케",
        "introduction": "1973년..."
      },
      {
        "seq": 2907,
        "type": "ILLUSTRATION",
        "name": "요시타케 신스케",
        "introduction": "1973년..."
      },
      {
        "seq": 2908,
        "type": "TRANSLATION",
        "name": "유문조",
        "introduction": "일본에서..."
      }
    ]
    =>
    [
      {
        seq: 2907,
        type: 'SCENARIO',
        name: '요시타케 신스케',
        introduction: '1973년...',
        typeText: '글,그림',
      },
      {
        seq: 2908,
        type: 'TRANSLATION',
        name: '유문조',
        introduction: '일본에서...',
        typeText: '옮김',
      },
    ];
    */
    const processedAuthorList = computed(() => {
      if (!props.isKidsBook) {
        return props.authors;
      } else {
        const authors = props.authors as KidsBookAuthorDTO[];

        return authors.reduce((list: KidsBookAuthorInfo[], cur: KidsBookAuthorDTO) => {
          const item = list.find((item) => item.seq === cur.seq);
          if (item) {
            item.typeText = item.typeText + ', ' + getTypeText(cur.type);
          } else {
            list.push({
              ...cur,
              typeText: getTypeText(cur.type),
            });
          }

          return list;
        }, []);
      }
    });

    return { processedAuthorList };
  },
});
